var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Observable } from "rxjs/Observable";
import { Subject } from 'rxjs/Subject';
import "rxjs/Rx";
import { DataService } from "./data.service";
import { timeout, catchError, take, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { AppHelper } from "../app.helper";
import { BaseHttpService } from "./base-http.service";
import { HttpClient } from "@angular/common/http";
var BusinesLogicService = (function (_super) {
    __extends(BusinesLogicService, _super);
    function BusinesLogicService(_blogic, _data) {
        var _this = _super.call(this, _blogic, _data) || this;
        _this._blogic = _blogic;
        _this._data = _data;
        _this.gatewayUrl = window.location.protocol + '//' + window.location.host + '/api/';
        _this.socketUrl = (window.location.protocol == 'https:') ? 'wss://' + window.location.host + '/ws/' : 'ws://' + window.location.host + '/ws/';
        _this.loginError = new Subject();
        _this.loginError$ = _this.loginError.asObservable();
        _this.loginMode = 0;
        _this.lastQueueData = null;
        _this.lastQueueList = null;
        _this.timeout = null;
        _this.lastqueue = null;
        _this.turns = [];
        _this.queueTimeout = null;
        _this.turnInProgress = false;
        _this.queueInProgress = false;
        return _this;
    }
    /* Http errors controller */
    BusinesLogicService.prototype.errorHandler = function (error) {
        switch (error.status) {
            case 400:
                this.loginError.next(error);
                break;
            case 422:
                this.loginError.next(error);
                break;
            case 500:
                break;
            case 404:
                break;
            case 401:
                break;
            case 403:
                this.loginError.next(error);
                break;
            case 428:
                this.loginError.next(error);
                break;
            default:
                this._data.redError = true;
                break;
        }
    };
    BusinesLogicService.prototype.handleRequest = function (observable) {
        var _this = this;
        return observable.pipe(take(1), timeout(10000), tap(function () { return _this._data.redError = false; }), catchError(function (error) {
            _this.turnInProgress = false;
            _this.queueInProgress = false;
            Observable.throw(_this.errorHandler(error));
            return of(null);
        }))
            .map(function (response) { return (response != null) ? response : null; });
    };
    BusinesLogicService.prototype.getOffices = function () {
        return this.handleRequest(this.get('office'));
    };
    BusinesLogicService.prototype.token = function (params) {
        if (params === void 0) { params = {}; }
        var newCredentials = {
            user: params["username"],
            pwd: params["pwd"],
            desk_id: params["desk_id"],
            application: AppHelper.APP_ID
        };
        var formData = new FormData();
        Object.keys(newCredentials).forEach(function (key) { return formData.append(key, newCredentials[key]); });
        return this.handleRequest(this.post('connect/token', formData));
    };
    BusinesLogicService.prototype.login = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.post('login/auth', params));
    };
    BusinesLogicService.prototype.getTicket = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.post('office/' + this._data.session["office"] + '/turn', params));
    };
    BusinesLogicService.prototype.listDesk = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.get('office/' + params['office_id'] + '/desk'));
    };
    BusinesLogicService.prototype.configDesk = function () {
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/config'));
    };
    BusinesLogicService.prototype.kindListOffice = function () {
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/kindoffice/ticket'));
    };
    BusinesLogicService.prototype.getPlanList = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/' + params["filter"]));
    };
    BusinesLogicService.prototype.getQueueInfo = function () {
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/stat/queue'));
    };
    BusinesLogicService.prototype.getDeskInfo = function () {
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/status/desk'));
    };
    BusinesLogicService.prototype.getKindInfo = function () {
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/stat/kind'));
    };
    BusinesLogicService.prototype.turnIsWaiting = function () {
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/desk/turninfo'));
    };
    BusinesLogicService.prototype.getSession = function () {
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/session'));
    };
    BusinesLogicService.prototype.getDeskPaused = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/turn?desk_id=' + params['desk_id'] + '&cpaused=true'));
    };
    BusinesLogicService.prototype.getQueueStatus = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/turn?firstqueue=' + params["queue_id"] + '&qassigned=' + params["assignedQueue"]));
    };
    BusinesLogicService.prototype.getChatList = function () {
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/desk/chat'));
    };
    BusinesLogicService.prototype.getAssist = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/assist/?turn_id=' + params["turn_id"]));
    };
    BusinesLogicService.prototype.getViewers = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/statusviewer/' + params["desk_id"] + '/zoneviewer'));
    };
    BusinesLogicService.prototype.deskOnline = function () {
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/desk/online'));
    };
    BusinesLogicService.prototype.checkDeskOnline = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.get('login/check/' + params["desk_id"]));
    };
    BusinesLogicService.prototype.getAllCalls = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.get('office/' + this._data.session["office"] + '/desk/lastcall/' + params['desk_id']));
    };
    BusinesLogicService.prototype.deskNotify = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.put('office/' + this._data.session["office"] + '/desk/' + params["desk_id"] + '/status', params));
    };
    BusinesLogicService.prototype.changeTurnKind = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/' + params["turn_id"] + '/kind/' + params["prekind_id"], params));
    };
    BusinesLogicService.prototype.setTicketInfo = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/' + params["turn_id"], params));
    };
    BusinesLogicService.prototype.printTicket = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/' + params["turn_id"] + '/print', params));
    };
    BusinesLogicService.prototype.setTurn = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/' + params["turn_id"] + '/desk', params));
    };
    BusinesLogicService.prototype.recallTurn = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/recall', params));
    };
    BusinesLogicService.prototype.cancelOperation = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.put('office/' + this._data.session["office"] + '/operation', params));
    };
    BusinesLogicService.prototype.setPausedTicket = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/' + params["turn_id"] + '/paused', params));
    };
    BusinesLogicService.prototype.moveTurn = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/' + params['turn_id'] + '/movement', params));
    };
    BusinesLogicService.prototype.setPostpone = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.put('office/' + this._data.session["office"] + '/turn/deferred/' + params["turn_id"], {}));
    };
    BusinesLogicService.prototype.changePassword = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.put('deskoperator/changepwd', params));
    };
    BusinesLogicService.prototype.deleteTurn = function (params) {
        if (params === void 0) { params = {}; }
        return this.handleRequest(this.delete('office/' + this._data.session["office"] + '/turn/' + params["turn_id"]));
    };
    BusinesLogicService.prototype.logout = function () {
        var newCredential = {
            username: this._data.session["username"],
            desk_id: JSON.parse(localStorage.getItem("desk")).id,
            application: AppHelper.APP_ID,
            id: this._data.session["id"],
        };
        return this.handleRequest(this.post('logout/activity', newCredential));
    };
    BusinesLogicService.prototype.ready = function () {
        var newCredentialReady = {
            username: this._data.session["username"],
            desk_id: JSON.parse(localStorage.getItem("desk")).id,
            application: AppHelper.APP_ID,
            id: this._data.session["id"],
        };
        return this.handleRequest(this.post('activity/ready', newCredentialReady));
    };
    BusinesLogicService.prototype.stop = function () {
        var newCredentialStop = {
            username: this._data.session["username"],
            desk_id: JSON.parse(localStorage.getItem("desk")).id,
            application: AppHelper.APP_ID,
            id: this._data.session["id"],
        };
        return this.handleRequest(this.post('activity/stop', newCredentialStop));
    };
    BusinesLogicService.prototype.getOnlineList = function () {
        var _this = this;
        this.deskOnline().subscribe(function (response) {
            _this._data.onlineDesks = response;
        });
    };
    BusinesLogicService.prototype.isDeskOnline = function (id) {
        var desk = this._data.onlineDesks.find(function (x) { return x["id"].toString() === id.toString(); });
        return !(typeof (desk) == 'undefined');
    };
    BusinesLogicService.prototype.getTurnList = function (params, forced) {
        var _this = this;
        if (forced === void 0) { forced = false; }
        if (this.lastQueueData == null || params["queue_id"] != this.lastqueue || forced) {
            this.lastqueue = params["queue_id"];
            this.turnInProgress = true;
            setTimeout(function () {
                _this.turnInProgress = false;
            }, 1500);
            return this.getQueueStatus(params);
        }
        else {
            return this.getLastQueueDataObservable();
        }
    };
    BusinesLogicService.prototype.getLastQueueDataObservable = function () {
        var _this = this;
        return new Observable(function (observer) {
            if (_this.timeout == null)
                _this.timeout = setTimeout(function () {
                    _this.lastQueueData = null;
                    _this.timeout = null;
                }, 5000);
            // observable execution
            observer.next(_this.lastQueueData);
            observer.complete();
        });
    };
    BusinesLogicService.prototype.getQueueList = function (params) {
        if (this.lastQueueList == null) {
            this.queueInProgress = true;
            return this.getPlanList(params);
        }
        else {
            return this.getLastQueueObservable();
        }
    };
    BusinesLogicService.prototype.getLastQueueObservable = function () {
        var _this = this;
        return new Observable(function (observer) {
            if (_this.queueTimeout == null)
                _this.queueTimeout = setTimeout(function () {
                    _this.lastQueueList = null;
                    _this.queueTimeout = null;
                }, 5000);
            // observable execution
            observer.next(_this.lastQueueList);
            observer.complete();
        });
    };
    return BusinesLogicService;
}(BaseHttpService));
export { BusinesLogicService };
